import { render } from "./messaggioInPrenotazione.vue?vue&type=template&id=2e08f5f2&ts=true"
import script from "./messaggioInPrenotazione.vue?vue&type=script&lang=ts"
export * from "./messaggioInPrenotazione.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__